"use client";
import { jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { Drawer } from "../../Drawer/index.js";
import { OverlayTitle } from "../../OverlaySearchHeader/index.js";
import { Calendar } from "../Calendar/Calendar.js";
function DatePickerMobileComponent({ mode = 'single', handleCalendarChange, components, open = false, handleDrawerState, heading = 'Choose Dates', popOverText, selected, footer, subHeading, ...restProps }) {
    const handleClose = useCallback(()=>{
        handleDrawerState(false);
    }, [
        handleDrawerState
    ]);
    const stickyFooter = useMemo(()=>!!footer, [
        footer
    ]);
    const headingCustomNode = useMemo(()=>/*#__PURE__*/ jsx(OverlayTitle, {
            heading: heading,
            subHeading: subHeading,
            handleClose: handleClose,
            popOverText: popOverText,
            slots: {
                container: 'px-4 pb-4'
            }
        }), [
        heading,
        subHeading,
        popOverText,
        handleClose
    ]);
    return /*#__PURE__*/ jsx(Drawer, {
        title: "Calendar",
        description: "Overlay Calendar",
        direction: "bottom",
        showCloseButton: false,
        showDragHandle: false,
        open: open,
        scroll: "body",
        footer: footer,
        stickyFooter: stickyFooter,
        headingCustomNode: headingCustomNode,
        children: /*#__PURE__*/ jsx("div", {
            className: "relative flex w-full p-4",
            children: /*#__PURE__*/ jsx(Calendar, {
                ...restProps,
                mode: mode,
                handleCalendarChange: handleCalendarChange,
                components: components,
                selected: selected
            })
        })
    });
}
const DatePickerMobile = /*#__PURE__*/ memo(DatePickerMobileComponent);
export { DatePickerMobile };
